var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
Messages.ModalFormView = function (superClass) {
  extend(ModalFormView, superClass);
  function ModalFormView(recipient_ids) {
    this.form_view = new Messages.FormView({
      recipient_ids: recipient_ids
    }, function (data) {
      return window.location.href = data.message.message_thread_url;
    });
    ModalFormView.__super__.constructor.call(this, {
      title: "Send a Message",
      contents: this.form_view.render(),
      width: "550px",
      close_on_esc: false
    });
    this.on('shown', function (_this) {
      return function () {
        return _this.form_view.after_render(_this.$el);
      };
    }(this));
  }
  return ModalFormView;
}(Widgets.ModalBox);
window.extend = extend;
window.hasProp = hasProp;